import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/(app)/layout.tsx");
